import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./lib/theme";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import About from "./pages/About";
import Stewardship from "./pages/Stewardship";
import Services from "./pages/Services";
import Projects from "./pages/Projects";
import Stories from "./pages/Stories";
import SeedCrisis from "./pages/SeedCrisis";
import Genetics from "./pages/Genetics";
import Intelligence from "./pages/Intelligence";
import Permits from "./pages/Permits";
import Training from "./pages/Training";
import Infrastructure from "./pages/Infrastructure";
import BushBotanics from "./pages/BushBotanics";
import BushMaps from "./pages/BushMaps";
import CommunityLedSeedCollection from "./pages/CommunityLedSeedCollection";
import Resources from "./pages/Resources";
import ResourceDetail from "./pages/ResourceDetail";
import Audience from "./pages/Audience";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/admin/Login";
import AdminDashboard from "./pages/admin/Dashboard";

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/stewardship" element={<Stewardship />} />
            <Route path="/services" element={<Services />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/stories" element={<Stories />} />
            <Route path="/seed-crisis" element={<SeedCrisis />} />
            <Route path="/genetics" element={<Genetics />} />
            <Route path="/seed-intelligence" element={<Intelligence />} />
            <Route path="/permits" element={<Permits />} />
            <Route path="/training" element={<Training />} />
            <Route path="/infrastructure" element={<Infrastructure />} />
            <Route path="/bush-botanics" element={<BushBotanics />} />
            <Route path="/bush-maps" element={<BushMaps />} />
            <Route path="/community-led-seed-collection" element={<CommunityLedSeedCollection />} />
            {/* legacy redirect from the old slug */}
            <Route
              path="/indigenous-seed-stewardship"
              element={<Navigate to="/community-led-seed-collection" replace />}
            />
            <Route path="/resources" element={<Resources />} />
            <Route path="/resources/:id" element={<ResourceDetail />} />
            <Route path="/audience/:slug" element={<Audience />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
